import { sessionStore } from "./session";
import { derived, type Readable } from "svelte/store";
import { getCopy } from "./copy";

// Somehow typescript doesn't like empty params functions to infer type, so we need to make explicit
export const getPageTitle: Readable<string> = derived([sessionStore, getCopy], ([$session, $getCopy]) => {
  const currentPath = $session.currentPath;
  const currentRoute = $session.routes.find((route) => route.path === currentPath);
  return ($getCopy(currentRoute?.id ?? "") as Record<string, string>).stepTitleCopy;
});

type StepNumberAndTotal =
  | {
      stepNumber: number;
      totalSteps: number;
    }
  | undefined;

export const getStepNumberAndTotal: Readable<StepNumberAndTotal> = derived([sessionStore], ([$session]) => {
  const currentPath = $session.currentPath;
  const routes = [...$session.routes];

  const landingRouteIndex = $session.routes.findIndex((route) => route.id === "landing");
  const reviewRouteIndex = $session.routes.findIndex((route) => route.id === "review");
  const surveyRouteIndex = $session.routes.findIndex((route) => route.id === "survey");

  const lastRouteIndex = surveyRouteIndex > -1 ? surveyRouteIndex : reviewRouteIndex;

  if (landingRouteIndex > -1 && lastRouteIndex > -1) {
    // Start is inclusive, end is not inclusive, so we add 1 to both indexes
    const progressRoutes = routes.slice(landingRouteIndex + 1, lastRouteIndex + 1);
    const currentRouteIndex = progressRoutes.findIndex((route) => route.path === currentPath);

    if (currentRouteIndex > -1) {
      return {
        stepNumber: currentRouteIndex + 1,
        totalSteps: progressRoutes.length
      };
    }
  }

  return undefined;
});
